import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"
import createEffectComposer from "./createEffectComposer"
import { getEngineThreeMainCamera } from "./getSetEngineThreeMainCamera"
import { getEngineThreeMainRenderer } from "./getSetEngineThreeMainRenderer"
import useMainScene from "./useMainScene"
import usePostProcessingRenderTarget from "./usePostProcessingRenderTarget"

const useEffectComposer = createSharedCachedFactory((engine) => {
  const renderTarget = usePostProcessingRenderTarget(engine)
  const scene = useMainScene(engine)
  const renderer = getEngineThreeMainRenderer(engine)
  const camera = getEngineThreeMainCamera(engine)
  const composer = createEffectComposer(
    scene, camera,
    renderer, renderTarget)
  return composer
})

export default useEffectComposer
